// API Configuration for Admin Panel
// Development'da proxy kullan, production'da direkt URL
export const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? '' // Development'da proxy kullan (CORS sorunu olmasın)
  : process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL && process.env.NODE_ENV === 'production') {
  console.error('REACT_APP_API_BASE_URL environment variable is not set for production!');
  throw new Error('API Base URL is required for production. Please set REACT_APP_API_BASE_URL in your environment.');
}
export const API_KEY = process.env.REACT_APP_API_KEY;

if (!API_KEY) {
  console.error('REACT_APP_API_KEY environment variable is not set!');
  throw new Error('API Key is required. Please set REACT_APP_API_KEY in your .env file.');
}

// API Configuration

// API Endpoints
export const API_ENDPOINTS = {
  // Staff endpoints
  STAFF_LOGIN: '/api/auth/staff/login',
  STAFF_PROFILE: '/api/staff/profile',
  STAFF_CHANGE_PASSWORD: '/api/staff/change-password',
  STAFF_ALL: '/api/staff/all',
  STAFF_ADD: '/api/staff/add',
  STAFF_UPDATE: '/api/staff',
  STAFF_UPDATE_STATUS: '/api/staff/{id}/status',
  STAFF_DELETE: '/api/staff',
  STAFF_BRANCHES: '/api/staff/branches',
  
  // Dogs endpoints
  DOGS_ALL: '/api/dogs/all',
  DOGS_PUBLIC: '/api/dogs/public',
  
  // Checkin endpoints
  CHECKIN_ACTIVE_STAFF: '/api/checkin/active-staff',
  CHECKIN_HISTORY: '/api/checkin/history',
  CHECKINS_TODAY: '/api/checkin/today',
  ACTIVE_DOGS: '/api/checkin/active-dogs',
  TODAY_DOGS: '/api/checkin/today-staff',
  CHECKIN_CHECKOUT: '/api/checkin/{id}/checkout',
  CHECKIN_COMPLETED_STAFF: '/api/checkin/completed-staff',
  
  // Reservation endpoints (old)
  RESERVATIONS: '/api/reservations',
  RESERVATIONS_TODAY: '/api/reservations/today',
  RESERVATIONS_OCCUPANCY: '/api/reservations/occupancy',
  RESERVATION_CHECKIN: '/api/reservations/{id}/checkin',
  RESERVATION_CHECKOUT: '/api/reservations/{id}/checkout',
  RESERVATION_CANCEL: '/api/reservations/{id}/cancel',
  
  // New Reservation endpoints (with branch & admin ID)
  RESERVATIONS_NEW: '/api/reservations-new',
  RESERVATIONS_NEW_BRANCH: '/api/reservations-new/branch',
  RESERVATIONS_NEW_ADMIN: '/api/reservations-new/admin',
  RESERVATIONS_NEW_TODAY: '/api/reservations-new/today',
  RESERVATIONS_NEW_STATS: '/api/reservations-new/stats',
  RESERVATIONS_NEW_DETAILS: '/api/reservations-new/{id}',
  RESERVATIONS_NEW_UPDATE: '/api/reservations-new/{id}',
  RESERVATIONS_NEW_CONFIRM: '/api/reservations-new/{id}/confirm',
  RESERVATIONS_NEW_CHECKIN: '/api/reservations-new/{id}/checkin',
  RESERVATIONS_NEW_CHECKOUT: '/api/reservations-new/{id}/checkout',
  RESERVATIONS_NEW_CANCEL: '/api/reservations-new/{id}/cancel',
  
  // Activity endpoints
  ACTIVITIES: '/api/activities',
  ACTIVITIES_TODAY: '/api/activities/today',
  ACTIVITIES_STATS: '/api/activities/stats',
  ACTIVITIES_PENDING_SHARES: '/api/activities/pending-shares',
  ACTIVITIES_DOG: '/api/activities/dog/{dogId}',
  ACTIVITY_ADD_PHOTO: '/api/activities/{id}/photo',
  ACTIVITY_SHARE: '/api/activities/{id}/share',
  
  // Users/Customers endpoints
  USERS_ALL: '/api/users',
  USERS_SEARCH: '/api/users/search',
  
  // Dog Activity Logs endpoints
  DOG_ACTIVITY_LOGS: '/api/dog-activity-logs',
  DOG_ACTIVITY_LOGS_BY_DOG: '/api/dog-activity-logs/dog/{dogId}',
  DOG_ACTIVITY_LOGS_BY_BRANCH: '/api/dog-activity-logs/branch/{branchId}',
  DOG_ACTIVITY_LOGS_BY_STAFF: '/api/dog-activity-logs/staff/{staffId}',
  DOG_ACTIVITY_LOGS_STATS: '/api/dog-activity-logs/stats',
  DOG_ACTIVITY_LOGS_RECENT: '/api/dog-activity-logs/recent',
  
  // Dog Status endpoints
  DOG_STATUS_BRANCH: '/api/dog-status/staff/branch',
  DOG_STATUS_DOG: '/api/dog-status/staff/dog/{dogId}',
  DOG_STATUS_CREATE: '/api/dog-status/staff',
  DOG_STATUS_UPDATE: '/api/dog-status/staff/{updateId}',
  DOG_STATUS_DELETE: '/api/dog-status/staff/{updateId}',
  
  // Admin Dog Status endpoints
  DOG_STATUS_ADMIN_UPDATE: '/api/dog-status/admin/{updateId}',
  DOG_STATUS_ADMIN_DELETE: '/api/dog-status/admin/{updateId}',
  
  // Reports endpoints
  REPORTS_MONTHLY_PAYMENT: '/api/reports/monthly-payment',
  REPORTS_MONTHLY_PAYMENT_EXCEL: '/api/reports/monthly-payment-excel',
  
  // Branches endpoints
  BRANCHES: '/api/branches',
  BRANCHES_UPDATE: '/api/branches/{id}',
  BRANCHES_CREATE: '/api/branches',
  
  // 2FA endpoints
  STAFF_2FA_SETUP: '/api/staff/2fa/setup',
  STAFF_2FA_VERIFY: '/api/staff/2fa/verify',
  STAFF_2FA_STATUS: '/api/staff/2fa/status',
  STAFF_2FA_DISABLE: '/api/staff/2fa/disable',
};

// Default headers for API requests
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'X-API-Key': API_KEY, // Always include API key since we have a fallback
};

// Helper function to get auth headers
export const getAuthHeaders = (token: string) => ({
  ...DEFAULT_HEADERS,
  'Authorization': `Bearer ${token}`,
  'X-API-Key': API_KEY, // Ensure API key is always included
});

// Helper function to check if token is expired and dispatch event
// Backend 401 döndüyse token zaten expire olmuş demektir, tekrar kontrol etmeye gerek yok
export const handleTokenExpired = (response: Response): boolean => {
  if (response.status === 401) {
    // Backend'den 401 geldiyse token expire olmuş demektir
    // Direkt event dispatch et, modal gösterilsin
    window.dispatchEvent(new CustomEvent('tokenExpired'));
    return true;
  }
  return false;
};

// Wrapper function for fetch that automatically handles token expiration
export const apiFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const response = await fetch(url, options);
  
  // Check for token expiration on 401 responses
  if (response.status === 401) {
    handleTokenExpired(response);
  }
  
  return response;
};

// Helper function to check response and handle token expiration
// Use this after any fetch call to automatically handle 401 errors
export const checkResponse = async (response: Response): Promise<Response> => {
  if (response.status === 401) {
    handleTokenExpired(response);
  }
  return response;
};